/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from '@angular/common';
import * as import4 from '../../buttons/link/link.component.ngfactory';
import * as import5 from '../../buttons/link/link.component';
import * as import6 from '../../buttons/button/button.component.ngfactory';
import * as import7 from '../../buttons/button/button.component';
import * as import8 from '../../orchestration/session.model';
import * as import9 from '../../orchestration/responsive.service';
import * as import10 from '../../notification/message/message.component.ngfactory';
import * as import11 from '../../notification/message/message.component';
import * as import12 from '../../notification/notification.service';
import * as import13 from '../../html-utils/html.pipe';
import * as import14 from '@angular/platform-browser';
import * as import15 from './ordering-context-panel.component';
import * as import16 from '../ordering-context.model';
import * as import17 from '../../order/order.model';
import * as import18 from '../ordering-context.controller';
import * as import19 from '../../orchestration/navigation.service';
const styles_OrderingContextPanelComponent:any[] = ([] as any[]);
export const RenderType_OrderingContextPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderingContextPanelComponent,
  data: {}
}
);
function View_OrderingContextPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'ordering-context-body-summary-primary-order-type'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.summaryOrderType));
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'ordering-context-body-summary-primary-asap-eta'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpod(['eta']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,3).transform('woa.heading.ordering-context.eta',ck(v,2,0,co.orderModel.orderEta)));
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'ordering-context-body-summary-primary-asap'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'ordering-context-body-summary-primary-asap-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_OrderingContextPanelComponent_4)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import3.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = ((co.orderingContextModel.canShowETA && !import0.ɵunv(v,7,0,import0.ɵnov(v,8).transform(co.OrderingContextEvents.evaluatingExpectedCompletionChange$))) && co.orderModel.orderEta);
    ck(v,7,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.heading.ordering-context.asap'));
    ck(v,3,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'ordering-context-body-summary-primary-time'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.summaryTime;
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'ordering-context-body-summary-primary-table'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.summaryTable;
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'ordering-context-body-summary-primary-from-store'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpod(['store']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,3,0,import0.ɵnov((<any>(<any>v.parent).parent),0),import0.ɵunv(v,0,0,import0.ɵnov(v,2).transform('woa.heading.ordering-context.fromStore',ck(v,1,0,co.primaryStore)))));
    ck(v,0,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'ordering-context-body-summary-primary-to-address'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpod(['address']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,3,0,import0.ɵnov((<any>(<any>v.parent).parent),0),import0.ɵunv(v,0,0,import0.ɵnov(v,2).transform('woa.heading.ordering-context.toAddress',ck(v,1,0,co.primaryAddress)))));
    ck(v,0,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'ordering-context-body-summary-primary'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_3)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_5)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_6)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_7)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_8)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.summaryOrderType;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.showAsap;
    ck(v,6,0,currVal_1);
    const currVal_2:any = co.summaryTime;
    ck(v,9,0,currVal_2);
    const currVal_3:any = co.summaryTable;
    ck(v,12,0,currVal_3);
    const currVal_4:any = co.primaryStore;
    ck(v,15,0,currVal_4);
    const currVal_5:any = co.primaryAddress;
    ck(v,18,0,currVal_5);
  },(null as any));
}
function View_OrderingContextPanelComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'ordering-context-body-summary-query'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.query));
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'ordering-context-body-summary-secondary-store'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.secondaryStore;
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',[[
        'class',
        'ordering-context-body-summary-secondary-link'
      ]
      ],(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.orderingContextController.viewCurrentStore()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import4.View_LinkComponent_0,import4.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import5.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.storeDetailsLink;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderingContextPanelComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'ordering-context-body-summary-secondary-address'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.secondaryAddress;
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'ordering-context-body-summary-secondary'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_11)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_12)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_13)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.secondaryStore;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.storeDetailsLink;
    ck(v,6,0,currVal_1);
    const currVal_2:any = co.secondaryAddress;
    ck(v,9,0,currVal_2);
  },(null as any));
}
function View_OrderingContextPanelComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-button',[[
        'class',
        'ordering-context-body-action'
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.orderingContextController.changeOrderingContext(co.timeOnly)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import6.View_ButtonComponent_0,import6.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import7.ButtonComponent,[
      import0.ElementRef,
      import8.SessionModel,
      import0.ChangeDetectorRef,
      import9.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      tier: [
        1,
        'tier'
      ]
      ,
      prominence: [
        2,
        'prominence'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = co.actionLabel;
    const currVal_28:any = co.ButtonTier.SECOND;
    const currVal_29:any = co.ButtonProminence.HIGH;
    ck(v,1,0,currVal_27,currVal_28,currVal_29);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderingContextPanelComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.orderingContextController.changeExpectedCompletion()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import4.View_LinkComponent_0,import4.RenderType_LinkComponent)),
      import0.ɵdid(49152,[[
        1,
        4
      ]
      ],0,import5.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.ordering-context.selectOrderTime';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderingContextPanelComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import10.View_ContentMessageComponent_0,import10.RenderType_ContentMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import11.ContentMessageComponent,[
      import0.ElementRef,
      import12.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,1,{links: 1}),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),1,1,(null as any),View_OrderingContextPanelComponent_16)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = co.orderModel.cannotAllocateOrderTimeMessage;
    ck(v,1,0,currVal_8,currVal_9);
    const currVal_10:any = co.showSelectTimeLink;
    ck(v,5,0,currVal_10);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
export function View_OrderingContextPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import13.HtmlPipe,[import14.DomSanitizer]),
      (l()(),import0.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'ordering-context-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'ordering-context-body-summary'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'ordering-context-body-summary'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_9)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_10)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_14)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_OrderingContextPanelComponent_15)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import3.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import15.OrderingContextPanelComponent = v.component;
    const currVal_0:any = (((((co.summaryOrderType || co.showAsap) || co.summaryTime) || co.summaryTable) || co.primaryStore) || co.primaryAddress);
    ck(v,8,0,currVal_0);
    const currVal_1:any = co.query;
    ck(v,11,0,currVal_1);
    const currVal_2:any = ((co.secondaryStore || co.storeDetailsLink) || co.secondaryAddress);
    ck(v,14,0,currVal_2);
    const currVal_3:any = co.showContextAction;
    ck(v,19,0,currVal_3);
    const currVal_4:any = (co.orderModel.cannotAllocateTime && !import0.ɵunv(v,23,0,import0.ɵnov(v,24).transform(co.OrderingContextEvents.evaluatingExpectedCompletionChange$)));
    ck(v,23,0,currVal_4);
  },(null as any));
}
function View_OrderingContextPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-ordering-context-panel',([] as any[]),(null as any),(null as any),(null as any),View_OrderingContextPanelComponent_0,RenderType_OrderingContextPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import15.OrderingContextPanelComponent,[
      import16.OrderingContextModel,
      import17.OrderModel,
      import9.ResponsiveService,
      import18.OrderingContextController,
      import19.NavigationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const OrderingContextPanelComponentNgFactory:import0.ComponentFactory<import15.OrderingContextPanelComponent> = import0.ɵccf('woa-ordering-context-panel',import15.OrderingContextPanelComponent,View_OrderingContextPanelComponent_Host_0,{timeOnly: 'timeOnly'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/ordering-context/ordering-context-panel/ordering-context-panel.component.ngfactory.ts